let _ = require('lodash');
let computed = require('baobab').monkey;
let SCHEME = require('../../../helpers/scheme');

const ERRORS_MAP = {
    notFound: 'Такого аккаунта не существует',
    internalError: 'Что-то пошло не так, попробуйте еще раз',
    invalidToken: 'Невалидный токен'
};

module.exports = {
    /**
     * Проверяем на то что все поля заполненны и валидны
     * @param {Object} state
     */
    restoreButton (state) {
        state.set(['restoreChange', 'computed', 'restoreButton', 'isEnabled'], computed(
            ['restoreChange', 'validation'],
            ['restoreChange', 'computed', 'validation', 'repeatPassword'],
            ['restoreChange', 'form'],
            ['restoreChange', 'ui', 'registerButton', 'isDisabled'],
            (error, repeatPassword, form, isDisabled) => {
                const requiredFields = ['password', 'repeatPassword'];
                let requiredKeys = _.keys(_.omitBy(form, (key) => !key));
                let differenceLength = _.difference(requiredFields, requiredKeys).length;

                return _.every([_.isEmpty(error), !repeatPassword, !differenceLength, !isDisabled]);
            }
        ));
    },

    setRepeatPasswordError (state) {
        state.set(['restoreChange', 'computed', 'validation', 'repeatPassword'], computed(
            ['restoreChange', 'validation', 'repeatPassword'],
            ['restoreChange', 'form', 'repeatPassword'],
            ['restoreChange', 'form', 'password'],
            (errorRepeatPassword, repeatPassword, password) => {
                if (!repeatPassword) {
                    return;
                }

                if (errorRepeatPassword) {
                    return errorRepeatPassword;
                }

                if (repeatPassword !== password) {
                    return _.get(SCHEME.repeatPassword, 'properties.value.messages.repeat');
                }
            }
        ));
    },

    errorState (state) {
        state.set(['restoreChange', 'computed', 'error', 'isError'], computed(
            ['restoreChange', 'error', 'errorType'],
            (errorType) => errorType
        ));
    },

    errorMessage (state) {
        state.set(['restoreChange', 'computed', 'error', 'text'], computed(
            ['restoreChange', 'error', 'errorType'],
            (errorType) => ERRORS_MAP[errorType]
        ));
    }
};



// WEBPACK FOOTER //
// ./actions/computed/auth/restore-change.js